"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
class JournalGrid extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "logweb",
            datatableName: "logwebdatatable",
            columns: [
                { id: "unid", header: (0, globals_1._)("N°"), width: 80, css: { "text-align": "right" }, sort: "int", hidden: false },
                { id: "message", header: (0, globals_1._)("Message"), width: 300, sort: "text" },
                { id: "dateHeure", header: (0, globals_1._)("Date et heure"), width: 180, sort: "text" },
                { id: "logLevel", header: (0, globals_1._)("Niveau"), width: 80, sort: "text" },
                { id: "fonctionAppli", header: (0, globals_1._)("Fonction"), width: 140, sort: "text" },
                { id: "module", header: (0, globals_1._)("Module"), width: 140, sort: "text" },
                { id: "ipAddress", header: (0, globals_1._)("IP"), width: 200, sort: "text" },
                { id: "data", header: (0, globals_1._)("Détails"), width: 400, sort: "text", editor: "popup" },
                { id: "identifiant", header: (0, globals_1._)("Identifiant"), width: 200, sort: "text" },
            ],
            title: (0, globals_1._)("Journal de l'application"),
            boutons: [],
            resizeColumn: true,
            urlData: globals_1.phpPath + "journal.php?option=list"
        });
    }
    init() {
        // fonction de recherche
        this.currentGrid = $$(this.datatableName);
        let me = this;
        this.searchField = $$("search");
        this.searchField.show();
        this.searchField.attachEvent("onTimedKeyPress", function () {
            let value = this.getValue().toLowerCase();
            me.currentGrid.filter(function (obj) {
                if (obj.message) {
                    let omessage = obj.message.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    return omessage.toLowerCase().indexOf(value) != -1;
                }
                return 0;
            });
        });
    }
}
exports.default = JournalGrid;
